import React from 'react'
import { IonAlert } from '@ionic/react'
import { ArrowRightIcon, DeleteIcon } from '../../conf/images'
import { useHistory } from 'react-router'
import { ScheduleRemindDetailPage } from '../../conf/routePath'
import { ScheduleRemindList } from './index'
import { deleteAlert } from '../../service/api/bot'

interface Props {
    mode: boolean
    item: ScheduleRemindList
    type?: string
    removeItem: (id: number) => void
}

const ScheduleRemindItem: React.FC<Props> = (props) => {
    const history = useHistory()
    const [showAlert, setShowAlert] = React.useState(false)
    const sureHandle = async () => {
        await deleteAlert(props.item.alert_id)
        setShowAlert(false)
        props.removeItem(props.item.alert_id)
    }
    const gotoDetail = () => {
        if (!props.item.alive) {
            setShowAlert(true)
        } else {
            if (props.mode) {
                history.push(ScheduleRemindDetailPage, {
                    item: props.item,
                    type: props.type,
                })
            }
        }
    }
    return (
        <div
            className={
                props.item.alive ? 'newsBotSetItem' : 'newsBotSetItem gray'
            }
            onClick={() => gotoDetail()}
        >
            <div className='item-warp'>
                <label>{props.item.title}</label>
                <div>
                    <span>提醒内容</span>
                    <p>{props.item.content[0]}</p>
                </div>
            </div>

            <div className='item-icon'>
                {props.mode ? (
                    <img src={ArrowRightIcon} alt='icon' />
                ) : (
                    <img
                        onClick={() => setShowAlert(true)}
                        src={DeleteIcon}
                        alt='icon'
                    />
                )}
            </div>

            <IonAlert
                isOpen={showAlert}
                onDidDismiss={() => setShowAlert(false)}
                header={'提示'}
                message={
                    props.item.alive
                        ? '您确定要删除这一项吗?'
                        : '该项提醒已失效，请确认是否删除'
                }
                buttons={[
                    {
                        text: '取消',
                        role: 'cancel',
                        handler: (blah) => {
                            setShowAlert(false)
                        },
                    },
                    {
                        text: '确认',
                        handler: () => sureHandle(),
                    },
                ]}
            />
        </div>
    )
}

export default ScheduleRemindItem
